import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { handleChange, handleClose, handleSave } from "./helpers";
import { state, ui } from "../../../../../../../../../interfaces/interfaces";

import FreeType from "./FreeType";
import GenericPopupModal from "../../../../../../../../Shared/GenericPopupModal";
import RadioSelect from "./Radio";
import React from "react";
import { questionsUtils } from "../../../../../../../../..";
import { useAppSelector } from "@store/hooks";
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";

const RequiredOptionsModal: React.FC = () => {
  const jobDescription = ui.ProblemComboJob?.jobDescription;
  const requiredOptionsChanged = useAppSelector(
    ({ state }) => state.RequiredOptionsChanged
  );

  // We intentionally re-run when requiredOptionsChanged changes,
  // even though it's not used directly.
  const questions = React.useMemo(
    () => questionsUtils.generateQuestions(),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [requiredOptionsChanged]
  );

  React.useEffect(() => {
    if (requiredOptionsChanged) {
      state.RequiredOptionsChanged = false;
    }
  }, [requiredOptionsChanged]);

  useDebugInformation("RequiredOptions", {
    jobDescription,
    requiredOptionsChanged,
  });
  return (
    <div>
      <Dialog
        open={ui.RequiredModal}
        onClose={() => handleClose(questionsUtils)}
        aria-labelledby="form-dialog-title"
        maxWidth="md"
        fullWidth
      >
        <DialogTitle id="form-dialog-title">{jobDescription}</DialogTitle>
        <DialogContent dividers>
          <DialogContentText>Required options:</DialogContentText>
          {questions.map((question, idx: number) =>
            question.type === "radio"
              ? ((question.required && question.dependent) ||
                  !question.dependent) && (
                  <RadioSelect
                    key={
                      question.question.toLowerCase().replaceAll(" ", "") +
                      "-" +
                      idx
                    }
                    options={question}
                    handleChange={(e, v) =>
                      handleChange(e, v, questionsUtils, idx)
                    }
                    sx={(theme: {
                      spacing: (arg0: number) => any;
                      breakpoints: { up: (arg0: number) => any };
                    }) => ({
                      marginTop: theme.spacing(1),
                      marginBottom: theme.spacing(1),
                      padding: theme.spacing(2),
                      [theme.breakpoints.up(
                        600 + Number(theme.spacing(3)) * 2
                      )]: {
                        marginTop: theme.spacing(1),
                        marginBottom: theme.spacing(2),
                        padding: theme.spacing(2),
                      },
                      "& input": { height: "1em" },
                    })}
                  />
                )
              : ((question.required &&
                  question.dependent &&
                  question.type !== "message") ||
                  !question.dependent) && ( // to prevent message from showing up as text field
                  <FreeType
                    options={question}
                    props={{}}
                    key={
                      question.question.toLowerCase().replaceAll(" ", "") +
                      "-" +
                      idx
                    }
                    handleChange={(e, v) =>
                      handleChange(e, v, questionsUtils, idx)
                    }
                    sx={(theme: {
                      spacing: (arg0: number) => any;
                      breakpoints: { up: (arg0: number) => any };
                    }) => ({
                      marginTop: theme.spacing(1),
                      marginBottom: theme.spacing(1),
                      padding: theme.spacing(2),
                      [theme.breakpoints.up(
                        600 + Number(theme.spacing(3)) * 2
                      )]: {
                        marginTop: theme.spacing(1),
                        marginBottom: theme.spacing(2),
                        padding: theme.spacing(2),
                      },
                      "& input": { height: "1em" },
                    })}
                  />
                )
          )}
          <FreeType
            options={{
              name: "Notes",
              question: "Additional Notes - Problem Related!",
              id: 9,
            }}
            props={{
              multiline: true,
              rows: 4,
              variant: "outlined",
            }}
            handleChange={(e, v) =>
              (state.RequiredOption10Answer = e.target.value)
            }
            sx={(theme: {
              spacing: (arg0: number) => any;
              breakpoints: { up: (arg0: number) => any };
            }) => ({
              marginTop: theme.spacing(1),
              marginBottom: theme.spacing(1),
              padding: theme.spacing(2),
              [theme.breakpoints.up(600 + Number(theme.spacing(3)) * 2)]: {
                marginTop: theme.spacing(1),
                marginBottom: theme.spacing(2),
                padding: theme.spacing(2),
              },
              "& input": { height: "1em" },
            })}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => handleSave(questionsUtils)}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
      {questions.map(
        (question, idx: number) =>
          question.type === "message" &&
          question.required &&
          question.dependent && (
            <GenericPopupModal
              key={
                question.question.toLowerCase().replaceAll(" ", "") + "-" + idx
              }
              modalTitle="Attention Required"
              adviseList={question.question.split("\n")}
              buttonText="Close Message"
              altJobTypes={question.altJobTypes}
            />
          )
      )}
    </div>
  );
};

export default React.memo(RequiredOptionsModal);
